export const NotFoundPage = (): React.ReactNode => {
    return <div>NotFoundPage</div>
}
